import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lkd-about',
  templateUrl: './about.component.html',
  styles: []
})
export class AboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
